import { Route } from 'react-router-dom';
import { createLazyRoute } from '@core/router';

const module = () => import('./module');

const scanRoutes = <Route path="q/*" {...createLazyRoute(module, m => m.scanDetailRoute)} />;

export default scanRoutes;
